import React, { createContext, useContext, ReactNode, useMemo } from "react";

interface ApiConfigContextType {
  getToken: () => string | Promise<string>;
}

const ApiConfigContext = createContext<ApiConfigContextType | undefined>(
  undefined,
);

export const ApiConfigProvider: React.FC<{
  children: ReactNode;
  baseUrl: string;
  getToken: ApiConfigContextType["getToken"];
}> = ({ children, getToken }) => {
  const value = useMemo(() => ({ getToken }), [getToken]);

  return (
    <ApiConfigContext.Provider value={value}>
      {children}
    </ApiConfigContext.Provider>
  );
};

export const useApiConfig = (): ApiConfigContextType => {
  const context = useContext(ApiConfigContext);
  if (!context) {
    throw new Error("useApiConfig must be used within an ApiConfigProvider");
  }
  return context;
};
